import baseUrl from "../config/baseUrl";

// Administration > Embed & API and the public /embed page.
// The signing secret is generated and kept on the server; the browser only
// ever receives it once, right after an admin regenerates it.

const request = async (path, { method = "GET", token, body } = {}) => {
  try {
    const response = await fetch(`${baseUrl}/api/${path}`, {
      method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await response.json();
    return { status: response.status, ...data };
  } catch (error) {
    return { code: 500, message: "Unable to reach the DMS server." };
  }
};

export const getEmbedSettings = ({ token }) =>
  request("embed-settings", { token });

export const updateEmbedSettings = ({ token, data }) =>
  request("embed-settings", { method: "POST", token, body: data });

// Admin only: fetched on demand for Copy / Show of the masked secret.
export const revealEmbedSecret = ({ token }) =>
  request("embed-secret", { method: "POST", token });

export const createEmbedPreviewToken =({ token, identifierType, identifierValue }) =>
  request("embed-preview-token", {
    method: "POST",
    token,
    body: { identifier_type: identifierType, identifier_value: identifierValue },
  });

export const createEmbedSession = ({ launchToken, projectKey }) =>
  request("embed/session", {
    method: "POST",
    body: { token: launchToken, ...(projectKey ? { project_key: projectKey } : {}) },
  });
